import { atom } from "recoil";

export interface ZoomAtomValue {
  name: string;
  id: string;
}

export const ZoomAtom = atom<ZoomAtomValue>({
  key: "ZoomAtom",
  default: { name: "100%", id: "2" },
});

export const ZoomAtomCampaignNotes = atom<ZoomAtomValue>({
  key: "ZoomAtomCampaignNotes",
  default: { name: "100%", id: "2" },
});
